module.exports = __webpack_public_path__ + "static/media/hourglass_item_additionb0f52697eaf124f6cbf40fe3d4912163.webp";